import { IconButton, Stack, Tooltip } from "@mui/material";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useTranslation } from "react-i18next";
import AddEditSuppliesPopup from "../../../add-edit-supplier";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useDeleteSupplierMutation } from "src/api/purchasing/suppliers";
import { oneBranchHasPermission } from "src/utils";
import { PurchasingPermissions } from "src/constants/permissions";

interface IAction {
  row: any;
  refetch: Function;
}

const TableActions = (props: IAction) => {
  const { t: T } = useTranslation("general");
  const { row, refetch } = props;
  const { id, reference } = row;
  const [open, setOpen] = useState(false);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  // APIS
  const { mutate, isPending, status, error } = useDeleteSupplierMutation();

  //permissions
  const editPermission = oneBranchHasPermission(
    PurchasingPermissions.editSupplier
  );
  const deletePermission = oneBranchHasPermission(
    PurchasingPermissions.deleteSupplier
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenEditPopup = () => setOpenEditPopup(true);
  const handleCloseEditPopup = () => setOpenEditPopup(false);

  const handleDelete = () => {
    mutate(row.id);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: T("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || T("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack direction={"row"} spacing={"12px"} justifyContent={"center"}>
      {editPermission && (
        <Tooltip title={T("edit")}>
          <IconButton onClick={handleOpenEditPopup}>
            <img src={EditIcon} alt="" />
          </IconButton>
        </Tooltip>
      )}
      {deletePermission && (
        <Tooltip title={T("delete")}>
          <IconButton onClick={handleOpen}>
            <img src={DeleteIcon} alt="" />
          </IconButton>
        </Tooltip>
      )}

      <AddEditSuppliesPopup
        open={openEditPopup}
        handleClose={handleCloseEditPopup}
        supplierToUpdate={row}
      />

      <ConfirmPopup
        open={open}
        item={row.name}
        handleClose={handleClose}
        handleConfirm={handleDelete}
        isPending={isPending}
      />
    </Stack>
  );
};
export default TableActions;
